export const CONDITION_CONFORMANCE_CASES = [
    {
        name: "a filled value satisfies the condition",
        expression: "price",
        values: { price: "89900" },
        expected: true,
    },
    {
        name: "a missing key does not satisfy the condition",
        expression: "price",
        values: {},
        expected: false,
    },
    {
        name: "a null value does not satisfy the condition",
        expression: "price",
        values: { price: null },
        expected: false,
    },
    {
        name: "an empty string does not satisfy the condition",
        expression: "price",
        values: { price: "" },
        expected: false,
    },
    {
        name: "a whitespace-only string does not satisfy the condition",
        expression: "price",
        values: { price: "   " },
        expected: false,
    },
    {
        name: "false counts as filled",
        expression: "armored",
        values: { armored: false },
        expected: true,
    },
    {
        name: "zero counts as filled",
        expression: "mileage",
        values: { mileage: 0 },
        expected: true,
    },
    {
        name: "an empty array does not satisfy the condition",
        expression: "gallery",
        values: { gallery: [] },
        expected: false,
    },
    {
        name: "a non-empty array satisfies the condition",
        expression: "gallery",
        values: { gallery: ["a.png"] },
        expected: true,
    },
    {
        name: "negation inverts a filled value",
        expression: "!price",
        values: { price: "89900" },
        expected: false,
    },
    {
        name: "negation inverts a missing key",
        expression: "!price",
        values: {},
        expected: true,
    },
    {
        name: "negation inverts a whitespace-only string",
        expression: "!price",
        values: { price: "   " },
        expected: true,
    },
    {
        name: "surrounding whitespace in the expression is ignored",
        expression: "  price  ",
        values: { price: "89900" },
        expected: true,
    },
    {
        name: "whitespace between the negation and the path is ignored",
        expression: "! price",
        values: {},
        expected: true,
    },
    {
        name: "a dotted path is read as a single path",
        expression: "item.promotional_price",
        values: { "item.promotional_price": "79900" },
        expected: true,
    },
    {
        name: "negation applies to a dotted path",
        expression: "!item.promotional_price",
        values: { "item.promotional_price": "" },
        expected: true,
    },
    {
        name: "an unsupported grammar never satisfies the condition",
        expression: 'mileage == "0"',
        values: { mileage: "0" },
        expected: false,
    },
    {
        name: "an unsupported grammar with a negation never satisfies the condition",
        expression: "!mileage > 3",
        values: { mileage: 10 },
        expected: false,
    },
];
